import { render, staticRenderFns } from "./MaterialsStock.vue?vue&type=template&id=33390fea&"
import script from "./MaterialsStock.vue?vue&type=script&lang=js&"
export * from "./MaterialsStock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports